export function FooterComponent(props: any) {
    return (
        <>
            <div className={"w-100 text-center"}>
                V.1.0 - 02.2021
            </div>
        </>
    )
}
